import React, { ReactNode, useCallback, useEffect, useState } from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import {
  DashboardNavigationDrawer,
  DashboardNavigationRail,
} from "../DashboardNavigation";
import AccountNavigation from "../AccountNavigation";
import {
  DASHBOARD_NAV_COLLAPSED_WIDTH,
  DASHBOARD_NAV_EXPANDED_WIDTH,
  useDashboardNavigationPreference,
} from "../../contexts/DashboardShellContext";

export type StudioNavigationControls = {
  onOpenNavigation?: () => void;
  closeNavigation: () => void;
  navigationOpen: boolean;
};

/** Use the dashboard rail on desktop and its modal navigation on smaller screens. */
export default function StudioNavigation({
  children,
}: {
  children: (controls: StudioNavigationControls) => ReactNode;
}) {
  const theme = useTheme();
  const desktop = useMediaQuery(theme.breakpoints.up("lg"));
  const { navigationOpen, setNavigationOpen } = useDashboardNavigationPreference();
  const [mobileOpen, setMobileOpen] = useState(false);
  useEffect(() => setMobileOpen(false), [desktop]);
  const closeNavigation = useCallback(() => {
    setNavigationOpen(false);
    setMobileOpen(false);
  }, [setNavigationOpen]);
  const width = desktop
    ? navigationOpen
      ? DASHBOARD_NAV_EXPANDED_WIDTH
      : DASHBOARD_NAV_COLLAPSED_WIDTH
    : 0;

  return (
    <>
      <Box sx={{ pr: `${width}px`, transition: "padding-right 0.22s ease" }}>
        {children({
          onOpenNavigation: desktop ? undefined : () => setMobileOpen(true),
          closeNavigation,
          navigationOpen: desktop ? navigationOpen : mobileOpen,
        })}
      </Box>
      {desktop && (
        <DashboardNavigationRail expanded={navigationOpen}>
          <AccountNavigation
            expanded={navigationOpen}
            onToggleExpanded={setNavigationOpen}
          />
        </DashboardNavigationRail>
      )}
      <DashboardNavigationDrawer
        open={!desktop && mobileOpen}
        onClose={() => setMobileOpen(false)}
      >
        <AccountNavigation
          expanded
          mobile
          onClose={() => setMobileOpen(false)}
        />
      </DashboardNavigationDrawer>
    </>
  );
}
